import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntPaginatorComponent} from "./int-paginator.component";

@NgModule({
  imports: [CommonModule],
  declarations: [IntPaginatorComponent],
  exports: [IntPaginatorComponent]
})
export class IntPaginatorModule {}
